export const getMicrosoftRedirectUri = (type: 'omya' | 'distributor' | boolean = 'omya') => {
  // Handle legacy boolean parameter for backward compatibility
  const isRelative = typeof type === 'boolean' ? type : false;
  
  const baseUrl = (import.meta.env.DEV || isRelative) ? '' : import.meta.env.VITE_APP_DOMAIN_URL;
  const reactNativeWebView = (window as any)?.ReactNativeWebView;

  if (reactNativeWebView) {
    const baseUrl = isRelative ? '' : 'https://admin.ces.omya.com';

    return `${baseUrl}/auth/microsoft-mobile`;
  }

  return `${baseUrl}/auth/login-omya`;
};